import styled from 'styled-components';
import { Card } from 'react-bootstrap';

export const PageContainer = styled.div`
  border: 0px solid red;
  background: #fff;
`;

export const Container = styled.div`
  background-color: #ffffff;
  height: 100vh;
  overflow: scroll;

  @media (max-width: 770px) {
    height: calc(96vh - 1rem);
  }

  @media (max-width: 770px) and (max-height: 770px) {
    height: calc(96vh - 1rem);
  }

  @media (max-width: 770px) and (max-height: 700px) {
    height: calc(95vh - 1rem);
  }

  @media (max-width: 770px) and (max-height: 600px) {
    height: calc(94vh - 1rem);
  }
`;

export const GridStatus = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
`;

export const Content = styled.div`
  margin-top: 1rem;
  margin-left: 20px;
  overflow-y: scroll;
  height: 85%;

  @media (max-width: 770px) {
    margin-top: 0rem;
  }
`;

export const PageTitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 1080px) {
    flex-wrap: wrap;
  }

  /* @media (min-width: 770px) and (max-width: 1100px) {
    width: 35%;
  } */

  @media (min-width: 350px) and (max-width: 550px) {
    width: 80% !important;
  }

  @media (max-width: 340px) {
    width: 90% !important;
    margin: 0 1rem 0 0;
  }
`;

export const PageTitle = styled.span`
  color: #808080;
  font-size: 20px;
  font-weight: 300;
`;

export const BackIcon = styled.span`
  display: flex;
  justify-content: flex-end;
  margin: 1rem 5rem 1.5rem 0;
  cursor: pointer;

  @media (max-width: 1366px) {
    margin-right: 30px;
  }

  @media (max-width: 770px) {
    margin: 1rem 1rem 0.3rem 0;
  }
`;

export const ValeIcon = styled.img`
  width: 39px;
  height: 26px;
  margin-right: 20px;
`;

export const StatusIcon = styled.img`
  width: 1rem;
  height: 1rem;
  margin-right: 4px;

  @media (max-width: 770px) {
    width: 0.85rem;
    height: 0.85rem;
  }
`;

export const ItemContainer = styled(Card)`
  width: 95%;
  height: auto;
  background-color: #ffffff;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  padding: 22px 0px 22px 29px;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
  border: 0.5px solid #c9c9c9;
  margin: 0.7rem 1rem;
  flex-direction: row;
  align-items: center;

  @media (max-width: 770px) {
    width: 92%;
    flex-direction: column;
    padding: 0.7rem 0 0.7rem 1rem;
    align-items: inherit;
  }
`;

export const MiddleMobile = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  @media (min-width: 770px) {
    display: none;
  }
`;

export const ItemTitle = styled.h1`
  font-size: 13px;
  color: #000fff;
  font-size: ${props => props.fontSize};
  font-weight: ${props => (props.weight ? props.weight : `550`)};

  @media (min-width: 770px) {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 0;
  }
`;

export const Status = styled.div`
  margin-bottom: 0.2rem;
  margin-top: -0.3rem;
  color: #000fff;
  font-weight: 550;
`;

export const ItemDetails = styled.div`
  color: #808080;
  font-size: 0.9rem;
  font-weight: 300;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 350px) {
    font-size: 0.7rem;
  }

  @media (max-width: 770px) {
    display: ${props => (props.desktop ? 'none' : 'flex')};
  }

  .align {
    display: flex;
    align-items: center;
  }
`;

export const Details = styled.span`
  width: 100px;
  text-align: center;
  background-color: #000fff;
  position: relative;
  color: white;
  padding: 0.15rem;
  border-bottom-left-radius: 0.8rem;
  border-top-left-radius: 0.8rem;

  @media (max-width: 500px) {
    padding: 0.2rem 0 0.2rem 0.4rem;
  }
`;

export const ImgDetails = styled.img`
  margin: 0 0 0.15rem 0.2rem;

  @media (max-width: 500px) {
    margin: 0px 0.1rem 0.1rem 0.2rem;
  }
`;

export const StatusCollor = styled.div`
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 2rem;
  margin: 0.2rem 0.3rem 0 0;
  background-color: ${props => {
    if (props.status === 'Bonificado') return `#00b205`;
    else return `#B20000`;
  }};
`;

export const ContainerItems = styled.div`
  margin-top: 2rem;

  @media (min-width: 770px) {
    margin-left: 1.5rem;
  }
`;

export const ContainerDesktop = styled.div`
  display: flex;
`;

export const ContainerStatus = styled.div`
  @media (min-width: 770px) {
    margin: 0.7rem 0 0 0;
  }
`;

export const DateTitle = styled.span`
  display: flex;
  flex-direction: column;

  @media (min-width: 770px) {
    margin-right: 1rem;
  }

  span {
    display: none;
    color: #969696;
    font-size: 0.8rem;

    @media (min-width: 770px) {
      display: block;
    }
  }
`;

export const MiddleDesktop = styled.div`
  display: flex;
  justify-content: space-betwen;
  @media (max-width: 770px) {
    display: none;
  }
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin: 0 0 0 2rem;
  @media (max-width: 1000px) {
    width: 100%;
  }
  @media (max-width: 770px) {
    margin-left: 30px;
  }
`;

export const Middle = styled.div`
  color: #000fff;
  font-size: 14px;
  align-items: center;
  flex-direction: row;
  @media (min-width: 1100px) {
    margin: 0 0 0 2rem;
  }
  @media (max-width: 1000px) {
    margin: 20px 0px;
  }
  @media (max-width: 770px) {
    display: none;
  }
`;

export const DivisionChangeCode = styled.div`
  width: 100%;
  margin-left: 5px;
  @media (max-width: 769px) {
    margin-left: 5px;
    width: 50%;
    margin: 0rem;
    background-color: white;
  }

  @media (max-width: 550) {
    width: 60%;
  }

  @media (max-width: 480) {
    width: 80%;
  }

  input {
    box-shadow: 0px 2px 4px #00000066;
    border-radius: 0.4rem;
    border: 0;
    padding: 0.2rem;
  }
`;

export const InsertCode = styled.div`
  display: flex;
  flex-direction: column;

  input {
    border: 1px solid #b0b0b0;
    @media(max-width: 770px) {
      margin-left: 5px;
      font-size: .85rem;
    }
  }
`;

export const RightCode = styled.div`
  width: 30%;
  margin: 1px;
  display: flex;
  align-items: center;
  flex-direction: row;
  font-size: 14px;

  @media(max-width: 1700px) {
    width: 40%;
  }

  @media(max-width: 1450px) {
    width: 34%;
  }

  @media(max-width: 1340px) {
    width: 30%;
  }

  @media(max-width: 1265px) {
    width: 25%;
  }

  @media(max-width: 1200px) {
    width: 14%;
  }

  @media(max-width: 1150px) {
    width: 30%;
  }

  @media (max-width: 770px) {
    display: none;
  }
`;

export const CodeMobile = styled.div`
  margin: 14px 0px 0px 0px;
  display: flex;
  align-items: center;
  flex-direction: row;
  font-size: 14px;
`;

export const Right = styled.div`
  color: #000fff;
  font-size: 14px;
  display: flex;
  align-items: center;
  flex-direction: row;
  @media (max-width: 770px) {
    display: none;
  }
`;

export const FilterMobile = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  width: 100%;
  @media (min-width: 770px) {
    display: none;
  }
`;

export const First = styled.div`
  margin: 14px 32px 0px 32px;

  @media (max-width: 770px) {
    margin: 14px 0px 0px 0px;
  }
`;

export const Second = styled.div`
  margin: 14px 32px 0px 32px;

  @media (max-width: 770px) {
    margin: 14px 0px 0px 0px;
  }
`;

export const FilterButton = styled.div`
  display: inline-flex;
  color: #fff;
  background-color: #000fff;
  border-radius: 13px;
  padding: 3px 14px;
  font-size: 14px;
  margin: 0px 5px;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
  }

  @media (max-width: 425px) {
    margin: ${props => (props.margin ? props.margin : '5px 5px')};
  }
`;

export const BoxStatus = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  font-size: 1rem;
  margin-bottom: -20px;
  span {
    color: #000fff;
  }

  @media (max-width: 770px) {
    font-size: 0.85rem;
  }
`;

export const PeriodSize = styled.div`
  font-size: 1rem;
  color: #000fff;
  display: inline-block;

  @media (max-width: 770px) {
    font-size: 0.85rem;
  }
`;

export const FilterButtonWhite = styled.div`
  display: inline-flex;
  color: #b2b2b2;
  background-color: #fff;
  border: 1px solid #b2b2b2;
  border-radius: 13px;
  padding: 3px 14px;
  font-size: 14px;
  margin: 0px 5px;
  justify-content: center;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 455px) {
    margin-top: 10px;
  }
`;

export const Close = styled.div`
  display: inline-flex;
  color: #000fff;
  background: #fff;
  width: 13px;
  height: 13px;
  border-radius: 20px;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  text-align: center;
  margin-left: 5px;
`;

export const Title = styled.div`
  color: #000fff;
  font-size: 18px;
  width: 300px;

  @media (max-width: 350px) {
    font-size: 14px;
  }
`;

export const HeaderContainer = styled.div`
  width: 100%;
  padding: 0;
  background-color: white;

  @media (max-width: 770px) {
    display: none;
  }
`;

export const IconLoadingMore = styled.i`
  font-size: 16px;
  color: #000fff;
`;

export const IconLoadingMoreWhite = styled.i`
  font-size: 16px;
  color: #ffffff;
`;

export const AlignNoVoucher = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1.6rem;

  @media (max-width: 770px) {
    margin-top: 1rem;
  }

  span {
    color: #808080;
  }
`;

export const HeaderMobileContainer = styled.div`
  @media (min-width: 770px) {
    display: none;
  }
`;

export const DivisionDowload = styled.div`
  margin: 2rem 2rem 0 0;

  a {
    margin-right: 20px;
    color: ${props =>
      props.children.props?.hasVoucher ? '#000FFF' : '#707070'};
  }

  @media (max-width: 770px) {
    a {
      font-size: 0.85rem;
    }

    display: flex;
    margin: 1rem 0 0 0rem;
    justify-content: flex-start;
    width: 100%;
  }
`;

export const DivisionTitleVales = styled.div`
  display: flex;
  align-items: center;
  color: #808080;
  margin: 2rem 0 0 2rem;

  @media (max-width: 770px) {
    margin: 3rem 0 0 1rem;
  }

  img {
    width: 2.3rem;
    height: 2.3rem;
  }

  h3 {
    font-size: 1.2rem;
    margin: 0 0 0 0.8rem;
  }
`;

export const DivisionFilters = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: 2rem 0 0 0;

  @media (max-width: 1100px) {
    margin: 1rem 0 0 2rem;
  }
`;
